import { render, staticRenderFns } from "./course.vue?vue&type=template&id=6ddc7389&scoped=true"
import script from "./course.vue?vue&type=script&lang=ts"
export * from "./course.vue?vue&type=script&lang=ts"
import style0 from "./course.vue?vue&type=style&index=0&id=6ddc7389&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ddc7389",
  null
  
)

export default component.exports